import { lang } from '../../assets/lang'

var messenger_bot_connectivity_thirdparty_webhook = !!window.xitFlowBuilderData.messenger_bot_connectivity_thirdparty_webhook
var google_sheet_access = !!window.xitFlowBuilderData.google_sheet_access

var thirdparty_webhook_display_class = 'd-none';
if(messenger_bot_connectivity_thirdparty_webhook)
  thirdparty_webhook_display_class = '';

var google_sheet_display_class = 'd-none';
if(google_sheet_access)
  google_sheet_display_class = '';

export const userInputFlowHtml = 
'<div class="form-group text-left mt-2 pb-3">' +
  '<label for="user-input-flow-list">' + lang.user_input_flow_html_label_flow + '</label>' +
  '<select id="user-input-flow-list" class="form-control select2">' +
  '</select>' +
'</div>' +

'<div id="user-input-flow-fields" class="text-left d-none">' +
  '<div class="form-group">' +
    '<label for="campaign-name">' + lang.user_input_flow_html_label_campaign + '</label>' +
    '<input name="campaign-name" id="campaign-name" value="" class="form-control" type="text">' +
  '</div>' +
'</div>' +

'<div class="form-group text-left mt-2 '+thirdparty_webhook_display_class+'">' + 
  '<label for="inputflow-webhook-url">' + lang.button_html_label_webhook_url + '</label>' +
  '<input type="text" class="form-control" id="inputflow-webhook-url">' +
'</div>' +

'<div class="form-group text-left mt-2 '+ google_sheet_display_class +'">' +
  '<label for="inputflow-google-sheets">' + lang.button_html_google_sheet_add + '</label>' +
  '<select id="inputflow-google-sheets" class="form-control select2" multiple="">' +
  '</select>' +
'</div>' 